import React from 'react';
import { func, array, number } from 'prop-types';
import { useTranslation } from 'react-i18next';

import useStyles from 'hooks/useStyles';
import BaseModal from 'components/BaseModal';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './CommentModal.scss';
import RatingInfo from '../../../RatingInfo';
import CommentBlock from '../CommentBlock';

const CommentModal = ({ averageRate, ratingCount, ratings, onClose }) => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);

  return (
    <BaseModal
      onClose={onClose}
      title={t('common.reviewDisplay.title')}
      classNameMap={{ root: styles.root, content: styles.content }}
      closable
      isScrollable
      isFullMode
    >
      <RatingInfo
        averageRate={averageRate}
        ratingCount={ratingCount}
        clickable={false}
      />
      {ratings.map(({ id, ...rating }) => (
        <CommentBlock key={id} {...rating} className={styles.comment} />
      ))}
    </BaseModal>
  );
};

CommentModal.propTypes = {
  onClose: func.isRequired,
  averageRate: number,
  ratingCount: number,
  ratings: array,
};

CommentModal.defaultProps = {
  averageRate: 0,
  ratingCount: 0,
  ratings: [],
};

export default CommentModal;
